import { PortainereeAlertingRule } from '@/react/portainer/generated-api/portainer/types.gen';

export type AlertRulesResponse = Array<AlertRuleRow>;

export interface AlertRuleEnvironment {
  endpointId: number;
  name: string;
  status: 'active' | 'excluded' | 'not_supported' | 'error' | 'pending';
  reasonCode: string;
  message: string;
  updatedAt: number;
}

export interface AlertRuleEnvironmentGroup {
  endpointGroupId: number;
  endpointGroupName: string;
  size: number;
  environments: AlertRuleEnvironment[];
}

export interface AlertRuleEnvironmentsResponse {
  groups: AlertRuleEnvironmentGroup[];
  total: number;
  active: number;
  excluded: number;
  notSupported: number;
  error: number;
  pending: number;
}

export type MetricType = 'percentage' | 'bytes' | 'raw' | 'days';

export type TierSeverity = 'info' | 'warning' | 'critical';

// TIER_SEVERITY_ORDER lists tier severities from most-severe to least-severe.
// Mirrors alertexpr.TierSeverityOrder on the backend.
export const TIER_SEVERITY_ORDER: readonly TierSeverity[] = [
  'critical',
  'warning',
  'info',
];

export type AlertRuleTier = {
  severity: TierSeverity;
  threshold: number;
  enabled: boolean;
};

export type AlertRuleTiersPayload = {
  description: string;
  enabled: boolean;
  conditionOperator: string;
  duration: number;
  tiers: AlertRuleTier[];
};

export type AlertRuleRow = {
  id: number;
  isInternal: boolean;
  name: string;
  description: string;
  category?: PortainereeAlertingRule['category'];
  enabled: boolean;
  severity: TierSeverity;
  threshold?: number;
  conditionOperator?: string;
  duration: number;
  metricType?: MetricType;
  createdBy: string;
  createdAt: string;
  updatedAt?: string;
  isEditable: boolean;
  promqlTemplate?: string;
  promqlScalarTemplate?: string;
  useTiers?: boolean;
  /** Tiers each measure their own series, so thresholds are not comparable. */
  independentTiers?: boolean;
  useDurationAsFor?: boolean;
  operatorFixed?: boolean;
  tiers?: AlertRuleTier[];
  labels?: Record<string, string>;
  summary?: string;
  alertManagerID: number;
  supportedAgentVersion?: string;
  supportedEnvironmentTypes?: string;
};

export type AlertRuleAttachments = {
  endpointGroupId: number;
  endpointGroupName: string;
  environments: {
    endpointId: number;
    name: string;
    status: string;
    message: string;
  }[];
}[];

export type AlertRuleAttachmentsPayload = {
  endpointGroupIds: number[];
};
